import { parseNumber, parseString } from 'utils/parsingHelpers'

export enum ResponsibleShop {
  PIT = 'PIT',
  HOU = 'HOU',
  UAE = 'UAE',
}

export enum RobotType {
  TOKA_5 = 'toka_5',
  TOKA_4 = 'toka_4',
  EMAT = 'emat',
  MFL = 'mfl',
  VACUUM_BOX = 'vacuum_box',
  HANDHELD_UT = 'hhut',
  NAVIC = 'navic',
}

export enum EquipmentConfig {
  CAMBER = 'camber',
  THREE_VIM = '3_vim',
  SD_THIN = 'sd_thin',
  SD_TANK = 'sd_tank',
  SD_THICK = 'sd_thick',
  TANK_SHELL = 'tank_shell',
  TANK_FLOOR = 'tank_floor',
  LARGE_TUBE = 'large_tube',
  SMALL_TUBE = 'small_tube',
  CROWN_RIDING = 'crown_riding',
  PAUT = 'paut',
  RAUT = 'raut',
  TRI_LAT = 'tri_lat',
  NO_CONFIG = 'no_config',
}

export enum ShippingMethods {
  CARRY_WITH_CREW = 'carry',
  FREIGHT_CARGO = 'freight_cargo',
}

export interface EquipmentDetailJSON {
  detail_id: string
  robot_type: RobotType
  num_robots: number
  num_spare_robots: number
  equipment_config: EquipmentConfig[]
  robot_config?: string
  responsible_shop: ResponsibleShop[]
  cal_block_requirements?: string
  shipping_methods: ShippingMethods
  num_spare_laptops: number
}

export const getResponsibleShopArray = (
  values: string[]
): ResponsibleShop[] => {
  if (
    values.every((value) =>
      Object.values(ResponsibleShop).includes(value as ResponsibleShop)
    )
  ) {
    return values as ResponsibleShop[]
  }
  return []
}

export const getRobotType = (value: string | undefined) => {
  if (Object.values(RobotType).includes(value as RobotType)) {
    return value as RobotType
  }
  return RobotType.TOKA_5
}

export const getEquipmentConfigArray = (
  values: string[]
): EquipmentConfig[] => {
  if (
    values.every((value) =>
      Object.values(EquipmentConfig).includes(value as EquipmentConfig)
    )
  ) {
    return values as EquipmentConfig[]
  }
  return []
}

export const getShippingMethod = (value: string | undefined) => {
  if (Object.values(ShippingMethods).includes(value as ShippingMethods)) {
    return value as ShippingMethods
  }
  return ShippingMethods.CARRY_WITH_CREW
}

export const parseEquipmentDetailJSON = (
  value: unknown
): EquipmentDetailJSON | undefined => {
  if (!value || typeof value !== 'object') return undefined

  const data = value as Record<string, unknown>
  return {
    detail_id: parseString(data.detail_id) ?? '',
    robot_type: getRobotType(parseString(data.robot_type)),
    num_robots: parseNumber(data.num_robots) ?? 0,
    num_spare_robots: parseNumber(data.num_spare_robots) ?? 0,
    equipment_config: getEquipmentConfigArray(
      Array.isArray(data.equipment_config)
        ? data.equipment_config.map((x) => String(x))
        : []
    ),
    robot_config: parseString(data.robot_config),
    responsible_shop: getResponsibleShopArray(
      Array.isArray(data.responsible_shop)
        ? data.responsible_shop.map((x) => String(x))
        : []
    ),
    cal_block_requirements: parseString(data.cal_block_requirements),
    shipping_methods: getShippingMethod(parseString(data.shipping_methods)),
    num_spare_laptops: parseNumber(data.num_spare_laptops) ?? 0,
  }
}
